import { Badge } from "@loot-os/ui/components/badge";

import { TRUST_TIER_LABELS } from "../lib/trustTiers";

const REASON_TEXT: Record<string, string> = {
  override: "Set by an editor; the computed tier is ignored.",
  locked: "Locked accounts are untrusted.",
  fraud_decline: "A SEON decline is on record.",
  kyc: "This environment requires identity verification and the shopper has not passed it.",
  unfunded: "No completed purchase or credit yet.",
  kyc_no_card: "Identity verified and never paid by card (boxed's super-trusted shortcut).",
  stripe_unsettled: "A Stripe purchase was attempted but never completed.",
  age: "From the age of the first funding event (or the last payment-method switch).",
};

/**
 * The end user's trust tier. `title` carries why, so the list and the sheet explain
 * themselves on hover without a second query.
 */
export function TrustTierBadge({
  tier,
  reason,
  overridden,
}: {
  tier: string;
  reason?: string;
  overridden?: boolean;
}) {
  const variant =
    tier === "untrusted" ? "destructive" : tier === "super_trusted" ? "default" : "secondary";
  return (
    <Badge variant={variant} title={reason ? (REASON_TEXT[reason] ?? reason) : undefined}>
      {TRUST_TIER_LABELS[tier] ?? tier}
      {overridden ? " · override" : ""}
    </Badge>
  );
}
